import * as React from "react";
const SvgFiRrCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-check_svg__a)">
      <path
        fill="#062147"
        d="M22.319 4.431 8.499 18.249a1 1 0 0 1-1.416 0L1.739 12.9a1 1 0 0 0-1.635.325 1 1 0 0 0 .218 1.092l5.346 5.345a3.01 3.01 0 0 0 4.25 0L23.736 5.847a1 1 0 1 0-1.417-1.416"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheck;
